import { FC } from "react";
import { SalifyLinkV2 } from "../ui/link/link";
import { DynamicCardProps } from "./types";
import HorizontalLayout from "./layouts/horizontal-layout";
import VerticalLayout from "./layouts/vertical-layout";
import FeaturedLayout from "./layouts/featured-layout";

const DynamicCard: FC<DynamicCardProps> = ({
  variant = "horizontal",
  imagePosition = "left",
  spacing = "normal",
  theme = "default",
  blocks,
  containerProps,
  link,
  onClick,
  showBorder = true,
  showBoxShadow = true,
  disableHover = false,
}) => {
  const getLayoutComponent = () => {
    const layoutProps = {
      blocks,
      imagePosition,
      spacing,
      theme,
      containerProps,
      showBorder,
      showBoxShadow,
      disableHover,
    };

    switch (variant) {
      case "vertical":
        return <VerticalLayout {...layoutProps} />;
      case "featured":
        return <FeaturedLayout {...layoutProps} />;
      case "horizontal":
      default:
        return <HorizontalLayout {...layoutProps} />;
    }
  };

  const content = getLayoutComponent();

  // Wrap with link if provided
  if (link) {
    return <SalifyLinkV2 href={link}>{content}</SalifyLinkV2>;
  }

  // Add click handler if provided
  if (onClick) {
    return (
      <div
        onClick={onClick}
        style={{ cursor: "pointer" }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick();
          }
        }}
        role="button"
        tabIndex={0}
      >
        {content}
      </div>
    );
  }

  return content;
};

DynamicCard.displayName = "DynamicCard";

export default DynamicCard;
